export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 py-16 md:py-20">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              <i className="ri-fire-line"></i>
              <span>全网热播</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-3">
              神马视频 · 全网热门影视一站畅享
            </h1>

            <p className="text-base md:text-lg text-foreground-600 font-heading italic mb-5">
              西瓜视频 · 菠萝视频 · 青青草视频 — 最新电影电视剧高清全集不缓冲
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
              神马视频汇聚西瓜视频免费、菠萝视频、青青草视频等主流平台的优质影视资源，覆盖最新电影、热播电视剧、经典老片与热门综艺，每日实时更新片源，全高清画质流畅不卡顿，无需注册即可免费在线观看。无论您是追剧达人还是电影爱好者，这里都是您的一站式影视乐园。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              <div className="flex items-center gap-2">
                <span className="text-2xl font-bold text-primary-500">2W+</span>
                <span className="text-xs text-foreground-500">影视资源</span>
              </div>
              <div className="w-px h-5 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl font-bold text-accent-500">每日更新</span>
                <span className="text-xs text-foreground-500">片源不断</span>
              </div>
              <div className="w-px h-5 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl font-bold text-primary-500">1080P</span>
                <span className="text-xs text-foreground-500">高清画质</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观看
              </a>
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-6 py-3 border-2 border-secondary-300 text-secondary-700 font-medium rounded-lg hover:bg-secondary-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-thumb-up-line text-lg"></i>
                精选推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=cinematic%20abstract%20movie%20collage%20with%20warm%20orange%20and%20gold%20tones%2C%20film%20strip%20elements%2C%20soft%20dramatic%20lighting%2C%20modern%20entertainment%20atmosphere%2C%20clean%20minimal%20composition%2C%20warm%20gradient%20background%20with%20subtle%20texture%2C%20artistic%20cinema%20aesthetic%2C%20no%20text%2C%20no%20recognizable%20faces&width=960&height=720&seq=hero-main-2026&orientation=landscape"
                alt="神马视频 - 全网热门影视一站式畅享平台"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}